module.exports = {
  defaultLocale: 'de',
  domainCode: 'ventilator-profis.de',
  fallbackLocale: 'cs',
  locales: 'de',
  theme: 'cvb',
}
